import styled from 'styled-components';

import { Box } from 'components/Box';
import { colors, gutterWidth } from 'theme';

const CenteredLayoutContainer = styled(Box)`
  margin: auto;
  max-width: 528px;
  width: 100%;
  padding-left: ${gutterWidth / 2}px;
  padding-right: ${gutterWidth / 2}px;
  color: ${colors.greyishBrown};
  line-height: 1.5;
`;
// eslint-disable-next-line import/no-default-export
export default CenteredLayoutContainer;
